import { CheckCircle, XCircle } from 'lucide-react';

interface PasswordRequirement {
  label: string;
  test: (password: string) => boolean;
}

interface PasswordRequirementsProps {
  password: string;
}

const requirements = [
  { test: (password: string) => password.length >= 8, label: 'At least 8 characters' },
  { test: (password: string) => /[A-Z]/.test(password), label: 'At least 1 uppercase letter (A-Z)' },
  { test: (password: string) => /[a-z]/.test(password), label: 'At least 1 lowercase letter (a-z)' },
  { test: (password: string) => /[0-9]/.test(password), label: 'At least 1 number (0-9)' },
  { test: (password: string) => /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/.test(password), label: 'At least 1 special character (!@#$%^&*)' },
];

export function PasswordRequirements({ password }: PasswordRequirementsProps) {
  if (!password) return null;

  return (
    <div className="space-y-2 mt-2">
      <div className="text-xs text-gray-600 font-medium">Password Requirements:</div>
      <div className="space-y-1">
        {requirements.map((requirement, index) => {
          const isMet = requirement.test(password);
          return (
            <div key={index} className="flex items-center gap-2 text-xs">
              {isMet ? (
                <CheckCircle className="w-3 h-3 text-green-500 flex-shrink-0" />
              ) : (
                <XCircle className="w-3 h-3 text-red-500 flex-shrink-0" />
              )}
              <span className={isMet ? 'text-green-600' : 'text-red-600'}>
                {requirement.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
